
import { motion } from "framer-motion";
import DueDiligenceSection from "./DueDiligenceSection";
import StrategyEvaluation from "./StrategyEvaluation";
import ProviderAssessment from "./ProviderAssessment";
import ExchangeSecurity from "./ExchangeSecurity";
import OngoingMonitoring from "./OngoingMonitoring";
import Conclusion from "./Conclusion";

const StrategiesSections = () => {
  return (
    <motion.section 
      initial={{ opacity: 0 }} 
      animate={{ opacity: 1 }} 
      transition={{ duration: 0.8 }} 
      className="space-y-8"
    >
      <DueDiligenceSection title="1. Introduction Premium Strategies">
        <p className="text-[#212529] leading-relaxed text-base">
          Due diligence is a critical step in evaluating and approving trading strategies, as it helps ensure that users are only exposed to reliable and well-managed options. By conducting a thorough review before a strategy is made available, Metrade allows traders to make better-informed decisions and reduces the likelihood of unforeseen risks. This process lays the groundwork for trust and transparency, guaranteeing that each strategy on the platform meets high standards of quality and consistency.
        </p>
      </DueDiligenceSection>

      <DueDiligenceSection title="2. Strategy Evaluation Premium Strategies">
        <StrategyEvaluation />
      </DueDiligenceSection>

      <DueDiligenceSection title="3. Provider Assessment Premium Strategies">
        <ProviderAssessment />
      </DueDiligenceSection>

      <DueDiligenceSection title="4. Exchange Security & Reliability">
        <ExchangeSecurity />
      </DueDiligenceSection>

      <DueDiligenceSection title="5. Ongoing Monitoring & Compliance">
        <OngoingMonitoring />
      </DueDiligenceSection>

      <DueDiligenceSection title="6. Conclusion">
        <Conclusion />
      </DueDiligenceSection>
    </motion.section>
  );
};

export default StrategiesSections;
